import script from "./MenuTree.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTree.vue?vue&type=script&setup=true&lang=js"

import "./MenuTree.vue?vue&type=style&index=0&id=e9d341e4&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\rnd_2023_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d341e4"]])

export default __exports__